import { cn } from '#/lib/utils';
// @ts-ignore
import { createIcon } from '@download/blockies';
import { HTMLAttributes, useEffect, useRef } from 'react';
import { getAddress, isAddress } from 'viem';

export interface AccountAvatarProps extends HTMLAttributes<HTMLElement> {
  address?: string | null;
  diameter?: number;
}

export function AccountAvatar({
  address,
  diameter = 24,
  ...props
}: AccountAvatarProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current!;
    const isValid = address != null && isAddress(address, { strict: false });
    const element = isValid
      ? createIcon({
          seed: getAddress(address).toLowerCase(),
          // size: 8,
          // scale: 3,
        })
      : document.createElement('div');
    element.className = cn('w-full h-full rounded-full overflow-hidden', {
      'bg-slate-300': !isValid,
    });
    container.appendChild(element);
    return () => {
      container.removeChild(element);
    };
  }, [address]);
  return <div ref={containerRef} {...props} />;
}
